import React from 'react';

import mapImage from '@vlabs/shared/assets/images/map/map.png';
import cn from 'classnames';
import { Map, Marker } from 'pigeon-maps';
import { osm } from 'pigeon-maps/providers';

import st from './MapCell.module.sass';

export const MapCell = ({ original, className }) => {
  return (
    <div className={cn(st.Map, className)}>
      {original?.location?.geo_position
        && (
          <div className={st.MapContent}>
            <Map
              attribution={false}
              defaultCenter={
                [original?.location.geo_position.latitude, original?.location.geo_position.longitude]
              }
              defaultZoom={17}
              provider={osm}
            >
              <Marker
                anchor={[original?.location.geo_position.latitude, original?.location.geo_position.longitude]}
                key={original?.event_id}
                payload={original}
              />
            </Map>
          </div>
        )}
      {!original?.location?.geo_position && (
        <img
          alt="map"
          className={st.Image}
          src={mapImage}
        />
      )}
    </div>
  );
};
